module.exports = __webpack_public_path__ + "img/1x.7bcb357.jpg";